/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function n(n){return[n("x"),n("y")]}export{n as eachAxis};
//# sourceMappingURL=each-axis.js.map
